import "./split.scss";

import PropTypes from "prop-types";
import React from "react";

import SmartErrorBoundary from "../../features/smartErrorBoundary";
import { PropTypeShapes } from "../../types";
import { withContainerContext } from "../container/ContainerContext";

const SplitPane = props => {
  const className = `aeonSplitPane ${props.shadow ? "shadow" : ""}`;

  let style = {};
  if (props.vertical) {
    style.width = `${props.containerRect.width}px`;
  } else {
    style.height = `${props.containerRect.height}px`;
  }

  return (
    <SmartErrorBoundary>
      <div className={className} style={style}>
        {props.children}
      </div>
    </SmartErrorBoundary>
  );
};

SplitPane.propTypes = {
  children: PropTypes.element.isRequired,
  vertical: PropTypes.bool.isRequired,
  position: PropTypeShapes.point.isRequired,
  shadow: PropTypes.bool,

  // From containerContext
  containerRect: PropTypeShapes.flatRect.isRequired
};

export default withContainerContext(SplitPane);
